module.exports = __webpack_public_path__ + "img/yiyang.d19cf1c9.jpg";